import socketCluster from 'socketcluster-client';
import dayjs from 'dayjs';

// --- Configuration ---
const options = {
  hostname: import.meta.env.VITE_SOCKET_HOST || 'localhost',
  port: Number(import.meta.env.VITE_SOCKET_PORT) || 8000,
  // This logic automatically enables wss:// on the standard HTTPS port.
  secure: Number(import.meta.env.VITE_SOCKET_PORT) === 443,
  ackTimeout: 60000,
  pingTimeout: 120000,
  pingInterval: 20000,
  connectTimeout: 120000,
  autoReconnectOptions: { initialDelay: 1000, randomness: 500, maxDelay: 4000 }
};

// --- Socket Instance Creation ---
// Create the single socket instance for the entire application.
const socket = socketCluster.create(options);
socket.options.pingTimeout = 120000;
socket.options.pingInterval = 20000;

window.socket = socket;

// --- Event Listeners ---
// Handle connection errors, ignoring token expiration errors for cleaner logs.
(async () => {
  for await (let { error } of socket.listener('error')) {
    if (error.name !== 'AuthTokenExpiredError') {
      console.error('Socket error:', error);
    }
  }
})();

// Log successful connections.
(async () => {
    for await (let event of socket.listener('connect')) {
      console.log('Socket connected with ID:', socket.id);
    }
})();

// --- RPC Wrapper Function ---
const debugging = false; // Set to true to enable performance logging

export const invokeRPC = async (controller, method, args = {}, options = {}) => {
  let requestTime;
  
  // Add the sender's socket ID to the payload
  args.sender_socket_id = socket.id;
  
  if (debugging) {
    requestTime = dayjs();
    args.request_time = requestTime.valueOf();
  }
  try {
    const data = await socket.invoke('messages', {
      controller,
      method,
      ...args
    }, options);
    if (debugging) {
      const responseTime = dayjs();
      console.log(`[DEBUG] RPC Response for ${controller}.${method}`, {
        round_trip_time: `${responseTime.diff(requestTime)}ms`,
        user: socket.authToken?.firstName,
      });
    }
    return data;
  } catch (error) {
    console.error(`RPC failed for ${controller}.${method}:`, error);
    throw error;
  }
};

// --- Exports ---
export default socket;